import Model, {
  attr,
  belongsTo,
  hasMany,
  type SyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type OrderModel from './order';
import type CompanyModel from './company';
import type UserModel from './user';
import type SupplierItemModel from './supplier-item';
import { htmlSafe } from '@ember/template';

export default class SupplierModel extends Model {
  declare [Type]: 'supplier';
  @attr()
  declare name: string;
  @attr()
  declare active: boolean;
  @attr()
  declare additional?: string;
  @attr()
  declare street?: string;
  @attr()
  declare street_number?: string;
  @attr()
  declare zip_code?: string;
  @attr()
  declare place?: string;
  @attr()
  declare telefon_number?: string;
  @attr()
  declare email?: string;
  @attr()
  declare fax?: string;
  @attr()
  declare delivery_time?: string;
  @attr()
  declare customer_number?: string;
  @attr()
  declare pdf_short_name?: string;

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;
  @attr()
  declare created_at: string;
  @attr()
  declare updated_at: string;

  @belongsTo('user', { async: false, inverse: null })
  declare created_by: UserModel;
  @belongsTo('user', { async: false, inverse: null })
  declare updated_by: UserModel;

  @hasMany('order', { async: false, inverse: 'supplier' })
  declare orders: SyncHasMany<OrderModel>;
  get openOrders() {
    return this.orders.filter((order) => !order.accepted_date);
  }
  @hasMany('supplier-item', { async: false, inverse: 'supplier' })
  declare supplierItems: SyncHasMany<SupplierItemModel>;
}
